import types from '@/actions/types';
import useConfig from '@/composables/useConfig';
import useAnalytics from '@/composables/useAnalytics';
import Base from '@/actions/base';

export default class ResetVariable extends Base {
  constructor(params) {
    super(params, types.RESET_VARIABLE);
  }

  execute() {
    const { resetVariables } = useConfig();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      const { variables } = this.params;
      if (variables) {
        resetVariables(variables);
      }
      resolve();
    });
  }

  stop() {
    this.resolve();
  }
}
